import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { LocationEntity } from './location.entity';
import { TripStopEntity } from './trip-stop.entity';

export type TripStopPhotoType =
	| 'before'
	| 'after'
	| 'damage'
	| 'inspection'
	| 'proof';

@Entity('trip_stop_photo')
@Index('idx_trip_stop_photo_stop', ['tripStopId'])
@Index('idx_trip_stop_photo_file', ['fileId'])
export class TripStopPhotoEntity extends BaseEntity {
	@Column({ name: 'fk_trip_stop__id', type: 'int', unsigned: true })
	public tripStopId!: number;

	@Column({
		name: 'fk_file__id',
		type: 'int',
		unsigned: true,
		nullable: true,
	})
	public fileId?: number | null;

	@Column({
		name: 'fk_location__id',
		type: 'int',
		unsigned: true,
		nullable: true,
	})
	public locationId?: number | null;

	@Column({ name: 'imageUrl', type: 'varchar', length: 255, nullable: true })
	public imageUrl?: string | null;

	@Column({
		name: 'thumbnailUrl',
		type: 'varchar',
		length: 255,
		nullable: true,
	})
	public thumbnailUrl?: string | null;

	@Column({ name: 'photoType', type: 'varchar', length: 50 })
	public photoType!: TripStopPhotoType;

	@Column({ name: 'notes', type: 'text', nullable: true })
	public notes?: string | null;

	@Column({
		name: 'latitude',
		type: 'decimal',
		precision: 10,
		scale: 8,
		nullable: true,
	})
	public latitude?: number | null;

	@Column({
		name: 'longitude',
		type: 'decimal',
		precision: 11,
		scale: 8,
		nullable: true,
	})
	public longitude?: number | null;

	@Column({ name: 'takenAt', type: 'datetime' })
	public takenAt!: Date;

	@Column({
		name: 'sortOrder',
		type: 'int',
		unsigned: true,
		default: 0,
	})
	public sortOrder!: number;

	@ManyToOne(() => TripStopEntity, (tripStop) => tripStop.photos)
	@JoinColumn({ name: 'fk_trip_stop__id' })
	public fkTripStop?: TripStopEntity;

	@ManyToOne(() => FileEntity)
	@JoinColumn({ name: 'fk_file__id' })
	public fkFile?: FileEntity;

	@ManyToOne(() => LocationEntity, { nullable: true })
	@JoinColumn({ name: 'fk_location__id' })
	public fkLocation?: LocationEntity;
}
